import { getSettingData } from "@/api/myPractice";
import { isObjEmpty } from "./helper";

// Shared in-flight request. The isObjEmpty guard alone only dedupes AFTER the
// response commits, so two concurrent dispatches would each fire their own
// request; holding the promise lets the second await the first.
let pendingFetch = null;

const payoutSetting = {
    namespaced: true,
    state: {
        old_personal: {},
        old_practice: {},
        // GET returns both levels in one call.
        infoURL: '/setting/getPayoutSetting',
        postpracticeURL: '/setting/setPayoutSettingClinic',
        postpersonalURL: '/setting/setPayoutSettingCustomer',
    },
    getters: {
        old_practice: state => state.old_practice,
        old_personal: state => state.old_personal,
        personalURL: state => state.postpersonalURL,
        practiceURL: state => state.postpracticeURL,
    },
    mutations: {
        SET_PRACTICE_DATA(state, practice_obj) {
            state.old_practice = practice_obj
        },
        SET_PERSONAL_DATA(state, personal_obj) {
            state.old_personal = personal_obj
        },
        SET_DEFAULT(state) {
            state.old_personal = {}
            state.old_practice = {}
        },
    },
    actions: {
        async getSettingData({ state, commit }) {
            if (!isObjEmpty(state.old_personal) || !isObjEmpty(state.old_practice)) return;
            if (pendingFetch) return pendingFetch;

            pendingFetch = (async () => {
                const res = await getSettingData(state.infoURL);
                commit("SET_PRACTICE_DATA", res.data?.practice || {})
                commit("SET_PERSONAL_DATA", res.data?.personal || {})
            })().finally(() => { pendingFetch = null; });

            return pendingFetch;
        },
        setPracticeData({ commit }, practiceData) {
            commit("SET_PRACTICE_DATA", practiceData)
        },
        setPersonalData({ commit }, personalData) {
            commit("SET_PERSONAL_DATA", personalData)
        },
    },
}

export default payoutSetting;
